import SelectInput from '../../Common/ui/selectInput'
import Input from '../../Common/ui/input'
import { Avatar, Box, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import Textarea from '../../Common/ui/textArea'
import { RadioGroup, RadioGroupItem } from '../../Common/ui/radio-group'
import MultiFileSelect from '../../Common/ui/MultiSelectFile'
import { useTranslation } from 'react-i18next'
import MultiSelectInput from '../../Common/ui/MultiSelect'
import dayjs from 'dayjs'
import * as EndPoints from '../../Entities/EndPoints'
import Axios from 'src/Axios'

const RiskSummary = ({ AllFormData, setAllFormData }) => {
    const { t } = useTranslation()
    const [ riskTypes, setRiskTypes ] = useState([])
    const [ allCategories, setAllCategories ] = useState([])
    const [ impactedDepartments, setImpactedDepartments ] = useState([])
    const [ AllMeasures, setAllMeasures ] = useState([])

    const { register, formState: { errors }, control } = useForm()

    const handleCheckRadioBox = (e) => {
        setAllFormData({ ...AllFormData, sourceRiskId: e })
    }

    const onValueChange = (e, name) => {
        setAllFormData({ ...AllFormData, [e.target.name]: e.target.value })
    }

    const handleOnValueChange = (e, name) => {
        setAllFormData({ ...AllFormData, mitigation: { ...AllFormData?.mitigation, [name]: e.target.value } })
    }

    const onValueSelectChange = (e, name) => {
        if (name === 'impactedDepartment' || name === 'suggestedMitigation' || name === 'impactOfRisk' || name === 'sharedOwnership' || name === 'riskOwner') {
            setAllFormData({ ...AllFormData, [name]: e })
        } else {
            setAllFormData({ ...AllFormData, mitigation: { ...AllFormData?.mitigation, [name]: e } })
        }
    }
    const instance = Axios.getInstance()

    const getAllRiskTypes = async () => {
        try {
            const response = await instance.get(EndPoints.API_ENDPOINT + '/masterController/GetAllRiskTypes')
            return response.data
        } catch (error) {
            console.error('Error fetching risk types:', error)
            throw error
        }
    }
    const getAllCategories = async () => {
        try {
            const response = await instance.get(EndPoints.API_ENDPOINT + '/masterController/GetAllCategories')
            return response.data
        } catch (error) {
            console.error('Error fetching risk types:', error)
            throw error
        }
    }
    const getAllDepartments = async () => {
        try {
            const response = await instance.get(EndPoints.API_ENDPOINT + '/masterController/GetAllDepartments')
            return response.data
        } catch (error) {
            console.error('Error fetching risk types:', error)
            throw error
        }
    }
    const getAllMeasures = async () => {
        try {
            const response = await instance.get(EndPoints.API_ENDPOINT + '/masterController/GetAllMeasures')
            return response.data
        } catch (error) {
            console.error('Error fetching risk types:', error)
            throw error
        }
    }

    useEffect(() => {
        const fetchRiskTypes = async () => {
            try {
                const types = await getAllRiskTypes()
                setRiskTypes(types)
            } catch (error) {
                console.error('Error fetching risk types:', error)
            }
            try {
                const types = await getAllCategories()
                setAllCategories(types)
            } catch (error) {
                console.error('Error fetching all categories:', error)
            }
            try {
                const types = await getAllDepartments()
                setImpactedDepartments(types)
            } catch (error) {
                console.error('Error fetching imp dept:', error)
            }
            try {
                const types = await getAllMeasures()
                setAllMeasures(types)
            } catch (error) {
                console.error('Error fetching imp dept:', error)
            }
        }

        fetchRiskTypes()
    }, [])

    return (
        <Typography>
            <Box sx={{ p: 4, display: 'flex', alignItems: 'center' }}>
                <p className='risk-content-title' style={{ margin: 0 }}>{t('Risk Summary')}</p>
                <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
            </Box>
            <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                <Box gridColumn="span 6">
                    <Typography sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography >{t('Risk Created By')}</Typography>
                        <Typography >
                            <Avatar alt='Barath' />
                        </Typography>
                        <Typography >
                            <Typography sx={{ color: 'hsl(var(--primary))', fontSize: '13px', fontWeight: 'bold' }}>{AllFormData?.name}</Typography>
                            <Typography sx={{ fontSize: '13px' }} >{AllFormData?.designation}</Typography>
                        </Typography>
                        <Typography >
                            <Typography sx={{ color: 'hsl(var(--primary))', fontSize: '13px', fontWeight: 'bold' }}>{t('Departnment')}</Typography>
                            <Typography sx={{ fontSize: '13px' }} >{AllFormData?.department}</Typography>
                        </Typography>
                        <Typography >
                            <Typography sx={{ color: 'hsl(var(--primary))', fontSize: '13px', fontWeight: 'bold' }}>{t('Created Date')}</Typography>
                            <Typography sx={{ fontSize: '13px' }} >{dayjs(AllFormData?.createdDate).format('DD-MM-YY')}</Typography>
                        </Typography>
                    </Typography>
                </Box>
                <Box gridColumn="span 6" />
                <Box gridColumn="span 3">
                    <TextField className='w-full' required variant='standard' id="outlined-required" onChange={onValueChange} name='title' label={t('Risk Title')} value={AllFormData?.title} />
                </Box>
                <Box gridColumn="span 6">
                    <TextField className='w-full' required variant='standard' id="outlined-required" onChange={onValueChange} name='description' label={t('Description')} value={AllFormData?.description}/>
                </Box>
                <Box gridColumn="span 3">
                    <TextField className='w-full' required variant='standard' id="outlined-required" onChange={onValueChange} label={t('Identified on')} value={dayjs(AllFormData?.createdDate).format('DD-MM-YY')} />
                </Box>
                <Box gridColumn="span 3">
                    <div className='mt-1'>
                        <p>{t('Source of Risk')}</p>
                        <RadioGroup className='flex' onValueChange={handleCheckRadioBox} value={AllFormData?.sourceRiskId} defaultValue={AllFormData?.sourceRiskId} >
                            <div className='flex items-center space-x-2'>
                                <RadioGroupItem value="Internal" />
                                <label className='text-sm'>{t('Internal')}</label>
                            </div>
                            <div className='flex items-center space-x-2'>
                                <RadioGroupItem value="External" />
                                <label className='text-sm'>{t('External')}</label>
                            </div>
                        </RadioGroup>
                    </div>
                </Box>
                <Box gridColumn="span 3">
                    <SelectInput label={t('Risk Nature')} required rules={{ required: 'This field is Required' }} control={control} errors={errors} name="type" placeholder="Select Risk Nature" onValueChange={onValueSelectChange} value={AllFormData?.type} options={riskTypes.map(type => ({ value: type.name, label: type.name }))} />
                </Box>
                <Box gridColumn="span 3">
                    <SelectInput label={t('Category')} required rules={{ required: 'This field is Required' }} control={control} errors={errors} name="category" placeholder="Select Category" onValueChange={onValueSelectChange} value={AllFormData?.category} options={allCategories.map(type => ({ value: type.name, label: type.name }))} />
                </Box>
                <Box gridColumn="span 3">
                    <MultiSelectInput label={t('Impacted Department')} control={control} errors={errors} name="impactedDepartment" placeholder={t('Select Impacted Department')} onValueChange={onValueSelectChange} value={AllFormData?.impactedDepartment} options={impactedDepartments?.map((data) => { return { id: data?.id, value: data?.name, label: data?.name, status: data?.status } })} />
                </Box>
                <Box gridColumn="span 6">
                    <Textarea errors={errors} control={control} required rules={{ required: 'This field is Required' }} name='impactOfRisk' label={t('Impacted of Risk')} register={register} placeholder="Enter Impacted of Risk" type="text" value={AllFormData?.impactOfRisk || ''} onValueChange={onValueSelectChange} />
                </Box>
                <Box gridColumn="span 6">
                    <Textarea errors={errors} control={control} required rules={{ required: 'This field is Required' }} name='suggestedMitigation' label={t('Suggested Mitigation')} register={register} placeholder="Enter Suggested Mitigation" type="text" value={AllFormData?.suggestedMitigation || ''} onValueChange={onValueSelectChange} />
                </Box>
                <Box gridColumn="span 6">
                    <Box gridColumn="span 6">
                        <MultiFileSelect
                            register={register}
                            errors={errors}
                            name="files"
                            label={t('Supporting Documents')}
                            required={false}
                            defaultValue={AllFormData?.supportingDocuments}
                        />
                    </Box>
                </Box>
                <Box gridColumn="span 3">
                    <MultiSelectInput label={t('Risk Owner')} required rules={{ required: 'This field is Required' }} control={control} errors={errors} name="riskOwner" placeholder={t('Select Risk Owner')} onValueChange={onValueSelectChange} value={AllFormData?.riskOwner} options={impactedDepartments?.map((data) => { return { id: data?.id, value: data?.name, label: data?.name, status: data?.status } })} />
                </Box>
                <Box gridColumn="span 3">
                    <MultiSelectInput label={t('Shared Ownership')} required rules={{ required: 'This field is Required' }} control={control} errors={errors} name="sharedOwnership" placeholder={t('Select Shared Ownership')} onValueChange={onValueSelectChange} value={AllFormData?.sharedOwnership} options={impactedDepartments?.map((data) => { return { id: data?.id, value: data?.name, label: data?.name, status: data?.status } })} />
                </Box>
            </Box>
            <Box sx={{ p: 4, display: 'flex', alignItems: 'center' }}>
                <p className='risk-content-title' style={{ margin: 0 }}>{t('Mitigation Plan')}</p>
                <div style={{ margin: '0px 20px 0px 20px', flex: 1, borderBottom: '3px solid hsl(var(--primary-foreground))' }}></div>
            </Box>
            <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={4} >
                <Box gridColumn="span 3">
                    <SelectInput label={t('Measures')} required rules={{ required: 'This field is Required' }} control={control} errors={errors} name="measuresId" placeholder="Select Measures" onValueChange={onValueSelectChange} value={AllFormData?.mitigation?.measuresId} options={AllMeasures.map(type => ({ value: type.name, label: type.name }))} />
                </Box>
                <Box gridColumn="span 6">
                    <Input errors={errors} control={control} required rules={{ required: 'This field is Required' }} name='mitigationDescription' label={t('Description')} register={register} placeholder="Enter Description" type="text" value={AllFormData?.mitigation?.mitigationDescription} onValueChange={handleOnValueChange} />
                </Box>
                <Box gridColumn="span 3">
                    <Input errors={errors} control={control} required rules={{ required: 'This field is Required' }} name='mitigationBudget' label={t('Mitigation Budget')} register={register} placeholder="Enter Mitigation Budget" type="text" value={AllFormData?.mitigation?.mitigationBudget} onValueChange={handleOnValueChange} />
                </Box>
                <Box gridColumn="span 3">
                    <Input errors={errors} control={control} required rules={{ required: 'This field is Required' }} name='availableAmount' label={t('Available Amount')} register={register} placeholder="Enter Available Amount" type="text" value={AllFormData?.mitigation?.availableAmount} onValueChange={handleOnValueChange} />
                </Box>
            </Box>
        </Typography>
    )
}

export default RiskSummary
